import React, { useState, useEffect } from 'react';
import { API } from '../../../../../API/API';
import { Panel, PanelType } from '@fluentui/react';
import Warning from '../../../../../components/Warning/Warning';
import ButtonSecondary from '../../../../../components/ButtonSecondary/ButtonSecondary';
import ButtonDefault from '../../../../../components/ButtonDefault/ButtonDefault';
import FieldDropdown from '../../../../../components/FieldDropdown/FieldDropdown';
import FieldText from '../../../../../components/FieldText/FieldText';
import FieldDate from '../../../../../components/FieldDate/FieldDate';
import FieldNumber from '../../../../../components/FieldNumber/FieldNumber';
import { message } from 'antd';
import { MessageConst } from '../../../../../const/MessageConst';
import { hideLoadScreen, showLoadScreen } from '../../../../../components/LoadScreen/LoadScreen';
import { constData } from '../../../../../const/Const';
import PanelBase from '../../../../../components/PanelBase/PanelBase';
import FieldItemList from '../../../../../components/FieldItemList/FieldItemList';

const HrEmpInvalNew = (props) => {
    const [initData] = useState({});
    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();
    const [dReason] = useState(constData.hrempinvalid_reason);
    const [dDuration] = useState(constData.hrempinvalid_duration);
    const [dDecision] = useState(constData.hrempinvalid_decision);
    const [checkRule, setCheckRule] = useState(false);

    const getExistData = async () => {
        let tData = { ...initData };
        if (props.entryid) {
            showLoadScreen();
            await API.get('/api/humanresource/employee/invalid?entryid=' + props.entryid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
            hideLoadScreen();
        }

        setData(tData);
    }

    useEffect(() => {
        if (props.entryid)
            getExistData();
    }, [props.entryid]);

    const fieldOnChanged = (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }

    }

    const onSave = async (p_close) => {

        let tRule = true;
        setCheckRule(true);
        if (!data.decision || !data.reason) {
            tRule = false;
        }

        let tData = { ...data };

        if (tRule) {
            showLoadScreen();

            tData.empid = props.empid;
            await API.post('/api/humanresource/employee/invalid', tData).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    onClear();
                    props.afterSave(p_close);
                }
            })
            hideLoadScreen();
        }
    }
    const onDelete = async (p_close) => {
        if (props.entryid) {
            await API.delete('/api/humanresource/employee/invalid?entryid=' + props.entryid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    onClear();
                    props.afterSave(p_close);
                }
            });
        }
    }

    const onDismiss = () => {
        onClear();
        props.onDismiss();
    }

    const onClear = () => {
        setData({ ...initData });
        setWarning();
        setCheckRule(false);
    }

    return (
        <PanelBase
            headerText={props.entryid > 0 ? "Засах" : "Нэмэх"}
            isOpen={props.onOpen}
            type={PanelType.medium}
            isFooterAtBottom={true}
            onDismiss={onDismiss}
            onDelete={() => onDelete(true)}
            warning={warning}
            delete={props.entryid}
            buttons={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div>
                        <ButtonSecondary onClick={() => onSave(false)} text="Хадгалаад шинэ" />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault onClick={() => onSave(true)} text="Хадгалах" />
                    </div>
                </div>
            }
        >
            <div style={{ marginTop: 20 }}>
                <FieldDropdown required title="ХЧА шалтгаан" onChanged={fieldOnChanged} keyfield='reason' defaultValue={data.reason} data={dReason} checkreq={checkRule} />
                <div style={{ marginTop: 13 }}>
                    <FieldItemList
                        title="Өвчний ангилал"
                        onChanged={fieldOnChanged}
                        keyfield='illnessid'
                        keyfieldname='illnessname'
                        defaultValue={[{ key: data.illnessid, name: data.illnessname }]}
                        dataurl="/api/humanresource/employee/invalid/get_illness_dropdown"
                    />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Групп тогтоосон огноо" onChanged={fieldOnChanged} keyfield='invalidbegdate' defaultValue={data.invalidbegdate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Үргэлжлэх хугацаа" onChanged={fieldOnChanged} keyfield='duration' defaultValue={data.duration} data={dDuration} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown required title="Комиссын шийдвэр" onChanged={fieldOnChanged} keyfield='decision' defaultValue={data.decision} data={dDecision} checkreq={checkRule} />
                </div>
            </div>
        </PanelBase>

    );
}

export default HrEmpInvalNew;